export enum SegmentButtonValue {
	Scan = 'scan',
	EnterCode = 'enter-code',
	Search = 'search',
}

export interface SegmentButton {
	value: SegmentButtonValue
	label: string
}
